module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step2_Image12b.82e36a4c.jpg";